import { css, CSSResult } from 'lit'
import { csColorFunctional } from '@cloudsuite/mosaic-shared/styles/colors.style.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

export const cscPrice = {
  percentageColor: css`var(--csc-price-percentage-color, ${csColorFunctional.sale})`,
}

/** Wrapper shown around price1/price2 when csc-price is used as a product tile widget */
export const cscPriceTile = {
  gap: css`var(--csc-price-tile-gap, ${csSpacing.spacing02})`,
  textAlign: css`var(--csc-price-tile-text-align, left)`,
}

export const style: CSSResult = css`
  .csc-price {
    display: flex;
    flex-direction: column;
    gap: ${csSpacing.spacing02};
  }

  .csc-price--placement-left {
    align-items: baseline;
    flex-direction: row;
    gap: ${csSpacing.spacing05};
  }

  .percentage {
    --cse-text-color: ${cscPrice.percentageColor};
  }

  .csc-product-tile-prices {
    display: flex;
    flex-direction: column;
    gap: ${cscPriceTile.gap};
    text-align: ${cscPriceTile.textAlign};
  }
`
